import template from './unit-authentication-google.html';
import controller from './unit-authentication-google.controller';

let unitAuthenticationGoogleComponent = {
    bindings: {},
    template,
    controller
};

export default unitAuthenticationGoogleComponent;



// WEBPACK FOOTER //
// ./client/app/components/unit/unit-authentication-google.component.js